module.exports = __webpack_public_path__ + "img/create-account.082f263b.png";